document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.bfcm2026-arcade').forEach(function (root) {
    // 链接带 ?part=new-release 时滚到本模块。放在视频判断之前，没有视频也能滚到。
    var part = new URLSearchParams(window.location.search).get('part');
    if (part && part === root.getAttribute('data-jump-id')) {
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 80;
      var top = root.getBoundingClientRect().top + window.pageYOffset - header - 16;
      window.scrollTo({ top: Math.max(top, 0), behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    var frame = root.querySelector('.bfcm2026-arcade__video');
    var toggleBtn = root.querySelector('.bfcm2026-arcade__video-toggle');
    if (!frame || !toggleBtn) return;

    // iframe 收不到父页面点击，所以盖一层按钮，用 YouTube 接口切换播放。
    var playing = frame.getAttribute('data-autoplay') === 'true';

    var send = function (command) {
      if (!frame.contentWindow) return;
      frame.contentWindow.postMessage(JSON.stringify({
        event: 'command',
        func: command,
        args: []
      }), '*');
    };

    var syncLabel = function () {
      var playLabel = toggleBtn.getAttribute('data-label-play') || 'Play video';
      var pauseLabel = toggleBtn.getAttribute('data-label-pause') || 'Pause video';
      toggleBtn.setAttribute('aria-label', playing ? pauseLabel : playLabel);
    };

    toggleBtn.addEventListener('click', function () {
      send(playing ? 'pauseVideo' : 'playVideo');
      playing = !playing;
      syncLabel();
    });

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches && playing) {
      // 地址里带了自动播放。播放器加载完才听得懂暂停，所以多发几次，点击仍可再开播。
      frame.addEventListener('load', function () {
        playing = false;
        syncLabel();
        var tries = 0;
        var stopAutoplay = function () {
          send('pauseVideo');
          tries += 1;
          if (tries < 5) window.setTimeout(stopAutoplay, 300);
        };
        stopAutoplay();
      });
    }

    syncLabel();
  });
});
